import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(t, e) {
  return n(), l("svg", r, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.542 6.387a1.2 1.2 0 0 0-1.076 0L7.668 8.286c-.408.203-.665.62-.665 1.076v1.665c-.075 2.813 1.772 5.41 4.555 6.71.228.106.525.101.803-.05.627-.34 1.01-.587 1.225-.738.146-.103.213-.16.226-.172a1 1 0 0 1 1.398 1.43 3.6 3.6 0 0 1-.473.377c-.29.204-.74.49-1.422.861-.778.422-1.744.506-2.604.104-3.35-1.566-5.802-4.806-5.708-8.562V9.362c0-1.213.685-2.323 1.77-2.865l3.798-1.899a3.2 3.2 0 0 1 2.866 0l3.795 1.899a3.2 3.2 0 0 1 1.77 2.865v1.668c0 1.22 0 2.773-1.167 4.525a1 1 0 1 1-1.665-1.11c.823-1.233.833-2.264.833-3.445V9.362c0-.456-.258-.873-.666-1.077z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: c };
export {
  d as default,
  c as render
};
//# sourceMappingURL=ic_insurance_sm-DAoKpH6Q.js.map
